/**
 * @generated SignedSource<<1731e26dcfca3af672eb7c7e948b60e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfigureDropTransactionDetails_metadata$data = {
  readonly collections: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"CollectionMedia_collection">;
  }>;
  readonly " $fragmentType": "ConfigureDropTransactionDetails_metadata";
};
export type ConfigureDropTransactionDetails_metadata$key = {
  readonly " $data"?: ConfigureDropTransactionDetails_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureDropTransactionDetails_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureDropTransactionDetails_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionType",
      "kind": "LinkedField",
      "name": "collections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CollectionMedia_collection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};

(node as any).hash = "02799723829d5e8f33973f7cd5b85c4b";

export default node;
